<template>
  <div class="py-5">
    <p>
      Your browser does not support zoom meetings within the browser. You can continue in the Zoom App. You will need to install Zoom if it is not yet on your
      device.
    </p>
    <p>
      The meeting passcode is <strong>{{ passcode }}</strong
      >.
    </p>
    <a :href="zoom_url">
      <button class="btn btn-info">Open in Zoom App</button>
    </a>
  </div>
</template>

<script>
export default {
  props: ['zoom_url', 'passcode'],
  computed: {},
  mounted() {},
  methods: {},
};
</script>
